<template>
  <div class="index-page">
    <div class="banner-box">
      <div class="main-body height-full relative">
        <div class="banner-bg"></div>
        <div class="banner-pic"></div>
        <div class="banner-text">
          <div class="banner-slogan">
            数智科技
            <span class="ml-slogan">赋能物流</span>
            <br />
            开放连接
            <span class="ml-slogan">共享生态</span>
          </div>
          <div class="banner-tips">
            共享百万级运力资源，整合海量大数据能力，为物流场景提供系统级接口能力和前沿解决方案，零门槛对接海量运力池，快速建立覆盖全国的物流业务能力，极速响应车货匹配需求，节约技术、用车、人效成本。
          </div>
        </div>
      </div>
    </div>
    <div>
      <div>
        <div class="merit-content">
          <newdoc />
        </div>
      </div>
    </div>
    <div class="merit-box">
      <div class="main-body">
        <div class="merit-content">
          <merit />
        </div>
      </div>
    </div>



    <div class="flow-box main-body">
      <div class="part-title">货拉拉开放平台为您提供</div>
      <support />
    </div>
    <div class="compare-box">
      <div class="main-body">
        <compare />
      </div>
    </div>
    <div class="flow-box main-body">
      <div class="part-title">接入流程</div>
      <flow />
    </div>
    <div class="solution-box">
      <div class="main-body">
        <div class="part-title">解决方案</div>
      </div>
      <solution />
    </div>
    <div class="case-box main-body">
      <div class="title-box">精准分析，解决各行货运难题</div>
      <case />
    </div>
  </div>
</template>

<script>
import Merit from './merit';
import Support from './support';
import Compare from './compare';
import Flow from './flow';
import Solution from './solution';
import Case from './case';
import Newdoc from './newdoc';

export default {
  name: 'index',
  components: {
    Merit,
    Support,
    Compare,
    Flow,
    Solution,
    Case,
    Newdoc,
  },
};
</script>

<style lang="scss" scoped>
.banner-box {
  width: 100%;
  height: 560px;
  background: #292f3e;
  .banner-bg {
    position: absolute;
    left: -44%;
    width: 100%;
    height: 100%;
    background: url('../../assets/img/index/ic_banner_bg.png') no-repeat;
    background-size: auto 560px;
    background-position: left 0;
  }
  .banner-pic {
    position: absolute;
    top: 28px;
    right: 80px;
    width: 485px;
    height: 470px;
    background: url('../../assets/img/index/ic_banner_pic.png') no-repeat;
    background-size: 100%;
  }
  .banner-text {
    position: relative;
    width: 420px;
    padding: 135px 0 0 30px;
    color: #fff;
    z-index: 1;
  }
  .ml-slogan {
    margin-left: 20px;
  }
  .banner-slogan {
    line-height: 64px;
    font-size: 40px;
    font-weight: bold;
  }
  .banner-tips {
    margin-top: 72px;
    font-size: 12px;
    line-height: 28px;
  }
}
.merit-box {
  padding: 77px 0;
  background: #efeff0;
  .merit-content {
    background: #fff;
    box-shadow: 0px 12px 25px 9px rgba(182, 182, 182, 0.25);
  }
}
.flow-box {
  padding: 50px 30px;
}
.compare-box {
  background: #292f3e;
}
.part-title {
  height: 30px;
  line-height: 30px;
  font-size: 24px;
  color: #212121;
  padding-left: 17px;
  border-left: 3px solid #f16222;
}
.title-box {
  color: #212121;
  font-size: 30px;
  line-height: 30px;
  padding-bottom: 23px;
  position: relative;
  text-align: center;
  &:after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50px;
    margin-left: -32px;
    width: 64px;
    height: 3px;
    background: #f16622;
  }
}

.solution-box {
  padding: 10px 0 50px;
}

.case-box {
  height: 520px;
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue